import React from 'react';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { WebsiteEditorVideoComponentFragment } from '@graphql/generated';
import { VideoAddEditProps } from '../../Video.types';
import { VideoForm } from '../../components/VideoForm';

export const VideoAddEdit: React.FC<VideoAddEditProps> = props => {
  const { customComponentBlockData: videoData } = useCustomComponentStateContext<WebsiteEditorVideoComponentFragment>();
  return (
    <VideoForm
      {...props}
      videoData={videoData}
    />
  );
};
